import React, {Component} from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText
} from 'reactstrap';

import {Bar, Doughnut, Line, Pie, Polar, Radar} from 'react-chartjs-2';

import Widget04 from './Widget04';

const doughnut = {
  labels: [
    'Red',
    'Green',
    'Yellow'
  ],
  datasets: [{
    data: [300, 50, 100],
    backgroundColor: [
      '#FF6384',
      '#36A2EB',
      '#FFCE56'
    ],
    hoverBackgroundColor: [
      '#FF6384',
      '#36A2EB',
      '#FFCE56'
    ]
  }]
};

const polar = {
  datasets: [{
    data: [
      11,
      16,
      7,
      3,
      14
    ],
    backgroundColor: [
      '#FF6384',
      '#4BC0C0',
      '#FFCE56',
      '#E7E9ED',
      '#36A2EB'
    ],
    label: 'My dataset' // for legend
  }],
  labels: [
    'Red',
    'Green',
    'Yellow',
    'Grey',
    'Blue'
  ]
};

import { inject, observer } from "mobx-react";

@inject("languageStore") @observer
class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    const { languageStore } = this.props;
    languageStore.loadInitialData();
  }

  render() {

    return (
      <div className="animated fadeIn">
      <p><em>This page shows some stats</em></p>
      <Row>
        <Col xs="12" sm="12">
          <CardGroup className="mb-4">
            <Widget04 icon="icon-people" color="info" header="87.500" value="25">Figuare A</Widget04>
            <Widget04 icon="icon-user-follow" color="success" header="385" value="25">Figuage B</Widget04>
            <Widget04 icon="icon-basket-loaded" color="warning" header="1238" value="25">Figuage C</Widget04>
            <Widget04 icon="icon-pie-chart" color="primary" header="28%" value="25">Figuage D</Widget04>
            <Widget04 icon="icon-speedometer" color="danger" header="5:34:11" value="25">Figuage E</Widget04>
          </CardGroup>
        </Col>
      </Row>
      <Row>
        <Col xs="12" xl="6">
          <Card>
            <CardHeader>
              Doughnut Chart
              <div className="card-actions">
                
              </div>
            </CardHeader>
            <CardBody>
              <div className="chart-wrapper">
                <Doughnut data={doughnut}/>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xs="12" xl="6">
        <Card>
            <CardHeader>
              Polar Area Chart
              <div className="card-actions">
                
              </div>
            </CardHeader>
            <CardBody>
              <div className="chart-wrapper">
                <Polar data={polar}/>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      </div>
    );
  }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js